<template>
    <div
        class="group my-4 w-full rounded-lg border border-iron-200 bg-white px-4 py-5 shadow-sm transition-all duration-200 hover:shadow-md"
    >
        <div class="items-center justify-between space-x-3 sm:flex">
            <div class="flex w-full items-center justify-between gap-2">
                <p class="font-medium text-iron-700">
                    {{ invitation.team.name }}
                    <span class="text-xs text-iron-500">
                        {{ $t("teams.invite_card.as") }} {{ invitation.role }}
                    </span>
                </p>
                <div class="flex gap-2">
                    <Button
                        size="sm"
                        @click="declineInvitation"
                        variant="outline"
                    >
                        {{ $t("teams.invite_card.decline") }}
                    </Button>
                    <Button size="sm" @click="acceptInvitation">
                        {{ $t("teams.invite_card.accept") }}
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import useConfirm from "../../ConfirmDialog/composables/useConfirm";
import { useI18n } from "vue-i18n";
import { computed, ref } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import route from "ziggy-js";
import { Button } from "@/components/ui/button";

const { show } = useConfirm();
const { t } = useI18n();

const props = defineProps({
    invitation: {
        required: true,
        type: Object,
    },
});

const page = usePage();
const loading = ref(false);
const user = computed((): any => page.props.user);

async function acceptInvitation() {
    router.post(
        route("app.teams.invitations.accept", {
            invitation: props.invitation.id,
        }),
    );
}

async function declineInvitation() {
    const success = await show({
        header: t("teams.invite_card.decline_confirmation_title"),
        message: t("teams.invite_card.decline_confirmation_description"),
        cancel: t("teams.invite_card.decline_confirmation_action"),
    });

    if (success) {
        router.delete(
            route("app.teams.invitations.decline", {
                invitation: props.invitation.id,
            }),
        );
    }
}
</script>
